export var LoggerCategoryEnum;
(function (LoggerCategoryEnum) {
    LoggerCategoryEnum["default"] = "default";
    LoggerCategoryEnum["analytics"] = "analytics";
    LoggerCategoryEnum["diagnostic"] = "diagnostic";
    LoggerCategoryEnum["api"] = "api";
    LoggerCategoryEnum["ui"] = "ui";
})(LoggerCategoryEnum || (LoggerCategoryEnum = {}));
export var LoggerLevelEnum;
(function (LoggerLevelEnum) {
    LoggerLevelEnum["log"] = "log";
    LoggerLevelEnum["error"] = "error";
    LoggerLevelEnum["info"] = "info";
    LoggerLevelEnum["warn"] = "warn";
    LoggerLevelEnum["debug"] = "debug";
})(LoggerLevelEnum || (LoggerLevelEnum = {}));
//# sourceMappingURL=LoggerCore.types.js.map